import React from 'react';

import { $l } from '../../../locales';

import css from './style.module.scss';

interface Props {
  onChatClick: () => void;
  onTicketClick: () => void;
  onBlankSpaceClick: () => void;
}

const OverlayActions = ({ onChatClick, onTicketClick, onBlankSpaceClick }: Props) => {
  const onOverlayClick = (e: React.MouseEvent) => {
    if ((e.target as HTMLDivElement).id === 'contact-us-overlay-content') {
      onBlankSpaceClick();
    }
  };

  return (
    <div onClick={onOverlayClick} className={css.overlayActions}>
      <div className={css.overlayActions__content} id="contact-us-overlay-content">
        <div className={css.overlayActions__actions}>
          <button className={css.overlayActions__action} onClick={onChatClick}>
            {$l('CONTACT_US.OVERLAY_LIVE_CHAT')}
          </button>
          <button className={css.overlayActions__action} onClick={onTicketClick}>
            {$l('CONTACT_US.OVERLAY_SUBMIT_TICKET')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverlayActions;
